import React from 'react'

export default function Home() {
  return (
    <div id="home" className='flex flex-col ml-10 h-[80vh] justify-center md:items-center '>

                <div className=' text-2xl sm:text-3xl lg:text-5xl' >Hey! I Am</div>
                <div className='text-5xl lg:text-7xl font-bold text-yellow-400 drop-shadow-lg z-0'>Utkarsh Dwivedi</div>
                <div className='text-1xl sm:text-3xl lg:text-4xl mt-2 text-gray-400'>I am a Full stack WEB-Developer and a Programmar</div>
    </div>
  )
}
